import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppConfig, CMPS_APP_CONFIG } from '../../../app.config';
import { catchErrorLogRet } from '../../../common/rest.operators';

import { UpViewProfile } from './model/up-view-profile.model';

@Injectable()
export class UserProfileService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    retrieve(userId: number, periodTypeId: number): Observable<UpViewProfile> {
        const params = new HttpParams().set(
            'periodTypeId',
            periodTypeId.toString(),
        );

        return this._http
            .get<UpViewProfile>(
                `${this._appConfig.API_ENDPOINTS.COACHING}/user-profile/users/${userId}/profile`,
                { params },
            )
            .pipe(catchErrorLogRet({}));
    }
}
